function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import digitalData from 'digital-data';
import { getState, setState } from '../../../analytics-state.js';
import { PEP, PAGE_AB_TEST, PRODUCTS_AVAILABILITY, PLP_GRID, NUCLEUS, NO_EVENT, PAGINATION, FILTER, SORT } from '../../../constants.js';
import { getContentProducts, setAnalytics, getProductAnalytics, getCategoryBreadCrumbs, getCurrentPage, shouldReInitAnalytics, getFilters } from '../../../thd-analytics-utils.js';
import { productPromise, browsePromise } from './pep.utils.js';
export function pep() {
  let cachedPepModel;
  let cachedProduct;
  const initPEP = () => {
    Promise.all([productPromise({
      cachedProduct
    }), browsePromise({
      cachedPepModel
    })]).then(dataList => {
      var _product$identifiers;
      if ((dataList === null || dataList === void 0 ? void 0 : dataList.length) < 2) return;
      const assignedData = dataList.reduce((acc, data, index) => {
        const newAcc = acc;
        newAcc[(data === null || data === void 0 ? void 0 : data.__typename) || index] = data;
        return newAcc;
      }, {});
      const {
        BaseProduct: product,
        SearchModel: pepModel
      } = assignedData;
      const {
        breadCrumbs = []
      } = (pepModel === null || pepModel === void 0 ? void 0 : pepModel.taxonomy) || {};
      const {
        products,
        searchReport,
        metadata,
        defaultPageSize
      } = pepModel || {};
      const {
        startIndex,
        pageSize,
        sortBy
      } = searchReport || {};
      const {
        pageType = '',
        pageTransitionEvent = NO_EVENT
      } = getState() || {};
      if (products !== null && products !== void 0 && products.length) {
        digitalData.content = _objectSpread(_objectSpread({}, digitalData.content), {}, {
          product: getContentProducts(products, pageType) || [],
          feature: {
            plpModule: products !== null && products !== void 0 && products.length ? 'y' : 'n'
          }
        });
      }
      const currentPage = getCurrentPage(startIndex, pageSize, defaultPageSize);
      setState(_objectSpread(_objectSpread({}, getState()), {}, {
        pageTransitionEvent: undefined,
        pageSize,
        currentPage
      }));
      if (!shouldReInitAnalytics(pageTransitionEvent)) {
        if (pageTransitionEvent === FILTER) {
          LIFE_CYCLE_EVENT_BUS.trigger('filters-refinements.publish', {
            breadCrumbs,
            searchReport,
            metadata,
            pageFilters: getFilters({
              appliedDimensions: pepModel === null || pepModel === void 0 ? void 0 : pepModel.appliedDimensions
            })
          });
        } else if (pageTransitionEvent === SORT) {
          LIFE_CYCLE_EVENT_BUS.trigger('sort-refinements.publish');
        }
        return;
      }
      digitalData.page = {
        pageInfo: {
          pageName: 'product entry page>' + (product === null || product === void 0 ? void 0 : (_product$identifiers = product.identifiers) === null || _product$identifiers === void 0 ? void 0 : _product$identifiers.itemId),
          pageLoadEvent: pageTransitionEvent === PAGINATION ? PAGINATION : 'pep view',
          pageType: PEP,
          platform: NUCLEUS,
          abTest: PAGE_AB_TEST
        },
        category: getCategoryBreadCrumbs(breadCrumbs) || {},
        displayAttributes: {
          pageNumber: getCurrentPage(startIndex, pageSize, defaultPageSize),
          productsAvailability: PRODUCTS_AVAILABILITY,
          sortBy,
          viewType: PLP_GRID
        },
        filter: getFilters({
          appliedDimensions: pepModel === null || pepModel === void 0 ? void 0 : pepModel.appliedDimensions
        })
      };

      // let serviceAddons; // Todo: Kalee killed the service addons, will fix it
      // if (info.hasServiceAddOns) {
      //   serviceAddons = yield selectState('dataSources.serviceAddons', { timeout: 3000 });
      // }

      digitalData.product = getProductAnalytics({
        product
      });
      digitalData.event = digitalData.event || [];
      setAnalytics(digitalData);
    });
  };
  initPEP();
  const onEventClick = function () {
    let {
      skipProduct = false,
      skipBrowse = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    initPEP(productPromise({
      skipProduct,
      cachedProduct
    }), browsePromise({
      skipBrowse,
      cachedPepModel
    }));
  };
  window.LIFE_CYCLE_EVENT_BUS.on('pagination.click', () => {
    onEventClick({
      skipProduct: true
    });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements.click', () => {
    onEventClick({
      skipProduct: true
    });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('sort-refinements.click', () => {
    onEventClick({
      skipProduct: true
    });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('super-sku.click-swatch', () => {
    onEventClick({
      skipBrowse: true
    });
  });
}
//# sourceMappingURL=pep.js.map